import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { sessionSlice } from './slices/session_slice';

const persistConfig = {
    key: 'root',
    storage,
}

const rootReducer = combineReducers({
    session: persistReducer(persistConfig, sessionSlice.reducer),
})

// Redux Store instantiation
export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({serializableCheck: false}),  // No need to concat thunk — it's included already
    devTools: process.env.NODE_ENV !== 'production',
});

// Explicitly type persistor
export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;